import InteragencyChat from './InteragencyChat';
import styles from './InteragencyChat.module.css';
import InteragencyChatHeader from './InteragencyChatHeader';

const InteragencyChatBox = () => {
  return (
    <div className={styles.container} data-name="interagency-chat-container">
      <InteragencyChatHeader />
      <InteragencyChat />
    </div>
  );
};

export default InteragencyChatBox;
